import { FC } from "react";
import {
  appointment_package,
  availableTeamMember,
} from "../../../../types/calendar";
import { Avatar, Button, Select, Tooltip } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { deleteIconSVG, editSVG } from "../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";
import { FaCircle } from "react-icons/fa6";
import { CiCircleCheck } from "react-icons/ci";
import PackagesSVG from "../../../../assets/catalog/PackagesSVG";
interface PackageProps {
  package: appointment_package;
  changeEditMode: (
    id: number,
    value: boolean,
    type: "service" | "package" | "product"
  ) => void;
  deletePackage: (index: number) => void;
  changeTeamMember: (
    id: number,
    teamMember: availableTeamMember,
    type: "service" | "package"
  ) => void;
  teamMembers: availableTeamMember[];
  canEdit: boolean;
}

const Package: FC<PackageProps> = ({
  package: packageItem,
  changeEditMode,
  changeTeamMember,
  teamMembers,
  deletePackage,
  canEdit,
}) => {
  const intl = useIntl();
  const temMembersOptions =
    teamMembers?.map((option: availableTeamMember) => {
      return {
        label: (
          <div className="flex items-center justify-between gap-2 px-2 ">
            <div className="flex gap-2 items-center w-full">
              <Avatar
                size={30}
                src={option?.media}
                className="bg-color-primary"
                icon={<UserOutlined />}
              >
                {option?.name?.charAt(0)}
              </Avatar>
              <p className=" ">{option?.name}</p>
            </div>
          </div>
        ),
        key: String(option?.id),
        value: String(option?.id),
      };
    }) || [];
  return (
    <div className="text-sm bg-[#EEF0FF] p-2 my-1 rounded">
      <div
        className=" flex gap-1 justify-between items-center  rounded bg-color-light-gray"
        key={packageItem?.id}
      >
        <div className="w-[25%] text-ellipsis flex gap-1 items-center">
          <PackagesSVG />
          <span>{packageItem?.package?.name}</span>
        </div>

        <div className=" w-[60%] flex-grow flex items-center gap-1">
          <div className="flex gap-2 items-center">
            <Tooltip title={packageItem?.team_member?.name}>
              <Avatar
                size={30}
                src={packageItem?.team_member?.media}
                icon={<UserOutlined />}
              />
            </Tooltip>
          </div>
          <div>
            <p className="flex gap-1 items-center ">
              <FaCircle size={8} color="#A9AEF6" />

              <span>{packageItem?.package?.package_category?.name}</span>
            </p>
          </div>
          <div className="flex gap-4 mx-2 items-center ">
            <p className="flex gap-1 items-center ">
              <FaCircle size={8} color="#9999A7" />

              <span>{packageItem?.package?.retail_price}</span>
              <small className="text-[10px] self-center mt-2">
                {intl.formatMessage({
                  id: "SARshort",
                })}
              </small>
            </p>
            <p className="flex gap-1 items-center ">
              <FaCircle size={8} color="#9999A7" />

              <span>{packageItem?.package?.total_time}</span>
              <small className="text-[10px] self-center mt-2">
                {" "}
                {intl.formatMessage({
                  id: "mins",
                  defaultMessage: "دقيقة",
                })}
              </small>
            </p>
          </div>
        </div>
        {canEdit ? (
          <div className="w-[15%]">
            <div className="flex items-center col-span-2 justify-end ">
              {canEdit ? (
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => {
                    changeEditMode(
                      packageItem?.id,
                      !packageItem?.editable,
                      "package"
                    );
                  }}
                >
                  {!packageItem?.editable ? (
                    editSVG
                  ) : (
                    <CiCircleCheck size={20} />
                  )}
                </Button>
              ) : null}
              {packageItem?.editable && canEdit ? (
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => {
                    deletePackage(packageItem?.id);
                  }}
                >
                  {deleteIconSVG}
                </Button>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      {packageItem?.editable && canEdit ? (
        <div className="rounded-select mt-3">
          <Select
            notFoundContent={
              <p className="text-red-700 p-2 font-semibold text-center">
                {intl.formatMessage({
                  id: "selectTeamMemberWarningText",
                  defaultMessage:
                    "لا يوجد عضو متاح في هذا الوقت لهذه الخدمات يرجى تغيير الوقت",
                })}
              </p>
            }
            placeholder={intl.formatMessage({
              id: "selectTeamMember",
              defaultMessage: "اختر عضو الفريق",
            })}
            onChange={(id) => {
              const teamMember = teamMembers.find(
                (member) => member?.id === Number(id)
              );
              if (!teamMember) return;
              changeTeamMember(packageItem?.id, teamMember, "package");
            }}
            className="  w-full rounded-full !bg-[#EEF0FF] h-12 "
            options={temMembersOptions}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Package;
